export default "__VITE_ASSET__86423f0c__"